/**
 * Author：brand
 * Creation Time：2019-03-30 10:48
 * Email：brandhuang@qq.com
 */

const emojiData = {
  "smiles": ["微笑", "/::)"],
  "pie-mouth": ["撇嘴", "/::~"],
  "lewd": ["色", "/::B"],
  "daze": ["发呆", "/::|"],
  "complacent": ["得意", "/:8-)"],
  "tears": ["流泪", "/::<"],
  "shy": ["害羞", "/::$"],
  "shut-up": ["闭嘴", "/::X"],
  "sleeping": ["睡", "/::Z"],
  "cry": ["大哭", "/::'("],//10
  "awkward": ["尴尬", "/::-|"],
  "angry": ["发怒", "/::@"],
  "naughty": ["调皮", "/::P"],
  "snag": ["呲牙", "/::D"],
  "amazed": ["惊讶", "/::O"],
  "sorry": ["难过", "/::("],
  "cool": ["酷", "/::+"],
  "cold-sweat": ["冷汗", "/:--b"],
  "crazy": ["抓狂", "/::Q"],
  "spit": ["吐", "/::T"],//10
  "titter": ["偷笑", "/:,@P"],
  "pleasant": ["愉快", "/:,@-D"],
  "supercilious-look": ["白眼", "/::d"],
  "arrogance": ["傲慢", "/:,@o"],
  "hunger": ["饥饿", "/::g"],
  "tired": ["困", "/:|-)"],
  "terrified": ["惊恐", "/::!"],
  "sweat": ["流汗", "/::L"],
  "simper": ["憨笑", "/::>"],
  "leisure": ["悠闲", "/::,@"],//10
  "strive": ["奋斗", "/:,@f"],
  "swear": ["咒骂", "/::-S"],
  "doubt": ["疑问", "/:?"],
  "hush": ["嘘", "/:,@x"],
  "faint": ["晕", "/:,@@"],
  "mad": ["疯了", "/::8"],
  "sorrow": ["哀", "/:,@!"],
  "skeleton": ["骷髅", "/:!!!"],
  "strike": ["敲打", "/:xx"],
  "goodbye": ["再见", "/:bye"],//10
  "wipe-perspiration": ["擦汗", "/:wipe"],
  "pick-nose": ["抠鼻", "/:dig"],
  "applaud": ["鼓掌", "/:handclap"],
  "embarrassing": ["糗大了", "/:&-("],
  "snicker": ["坏笑", "/:B-)"],
  "left-hem": ["左哼哼", "/:<@"],
  "right-hem": ["右哼哼", "/:@>"],
  "yawn": ["哈欠", "/::-O"],
  "contempt": ["鄙视", "/:>-|"],
  "grievance": ["委屈", "/:P-("],//10
  "fast-cry": ["快哭了", "/::'|"],
  "cattiness": ["阴险", "/:X-)"],
  "kiss": ["亲亲", "/::*"],
  "scare": ["吓", "/:@x"],
  "pitiful": ["可怜", "/:8*"],
  "kitchen-knife": ["菜刀", "/:pd"],
  "watermelon": ["西瓜", "/:<W>"],
  "beer": ["啤酒", "/:beer"],
  "basketball": ["篮球", "/:basketb"],
  "ping-pong": ["乒乓", "/:oo"],//10
  "coffee": ["咖啡", "/:coffee"],
  "meal": ["饭", "/:eat"],
  "pig": ["猪头", "/:pig"],
  "rose": ["玫瑰", "/:rose"],
  "fade": ["凋谢", "/:fade"],
  "lip": ["嘴唇", "/:showlove"],
  "heart": ["爱心", "/:heart"],
  "heart-broken": ["心碎", "/:break"],
  "cake": ["蛋糕", "/:cake"],
  "lightning": ["闪电", "/:li"],//10
  "bomb": ["炸弹", "/:bome"],
  "knife": ["刀", "/:kn"],
  "football": ["足球", "/:footb"],
  "ladybird": ["瓢虫", "/:ladybug"],
  "potbellied": ["便便", "/:shit"],
  "moon": ["月亮", "/:moon"],
  "sun": ["太阳", "/:sun"],
  "gifts": ["礼物", "/:gift"],
  "hug": ["拥抱", "/:hug"],
  "strong": ["强", "/:strong"],//10
  "weak": ["弱", "/:weak"],
  "handshake": ["握手", "/:share"],
  "victory": ["胜利", "/:v"],
  "fuels": ["抱拳", "/:@)"],
  "seduce": ["勾引", "/:jj"],
  "fist": ["拳头", "/:@@"],
  "disappointing": ["差劲", "/:bad"],
  "love-you": ["爱你", "/:lvu"],
  "no": ["NO", "/:no"],
  "ok": ["OK", "/:ok"],//10
  "love": ["爱情", "/:love"],
  "throw-kiss": ["飞吻", "/:<L>"],
  "jump": ["跳跳", "/:jump"],
  "shiver": ["发抖", "/:shake"],
  "sulking": ["怄火", "/:<O>"],
  "whirl": ["转圈", "/:circle"],
  "kowtow": ["磕头", "/:kotow"],
  "look-back": ["回头", "/:turn"],
  "rope-skipping": ["跳绳", "/:skip"],
  "surrender": ["投降", "/:oY"],//10
  "excite": ["激动", "/:#-0"],
  "flurry": ["乱舞", "/:hiphot"],
  "kiss-offering": ["献吻", "/:kiss"],
  "left-tai-chi": ["左太极", "/:<&"],
  "hey": ["嘿哈", "[Hey]"], // 微信新表情
  "facepalm": ["捂脸", "[Facepalm]"],
  "smirk": ["奸笑", "[Smirk]"],
  "smart": ["机智", "[Smart]"],
  "concerned": ["皱眉", "[Concerned]"],
  "yeah": ["耶", "[Yeah!]"],
  "packet": ["红包", "[Packet]"],
  "blessing": ["福", "[Blessing]"],
  "smile": ["笑脸", "😄"],
  "mask": ["生病", "😷"],
  "joy": ["破涕为笑", "😂"],
  "stuck_out_tongue_closed_eyes": ["吐舌", "😛"],
  "flushed": ["脸红", "😳"],
  "scream": ["恐惧", "😱"],
  "pensive": ["失望", "😞"],
  "unamused": ["无语", "😒"],
  "ghost": ["鬼魂", "👻"],
  "pray": ["合十", "🙏"],
  "muscle": ["强壮", "💪"],
  "tada": ["庆祝", "🎉"],
  "gift": ["礼品", "🎁"],
}

export default emojiData